import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useCurveStore } from '@/stores/useCurveStore';
import { motion } from 'framer-motion';

export const CurveEditor = () => {
  const { points, setPoint } = useCurveStore();

  const handleRateChange = (month: number, value: number) => {
    setPoint(month, Math.max(0, Math.min(10, value)));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Edit Recovery Rates</CardTitle>
        <CardDescription>
          Adjust monthly recovery rates (0-10% of nominal value)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[500px] pr-4">
          <div className="space-y-3">
            {points.map((point, index) => (
              <motion.div
                key={point.month}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.01 }}
                className="grid grid-cols-[80px_1fr_100px] gap-4 items-center p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors"
              >
                <div className="text-sm font-medium">
                  Month {point.month}
                </div>
                
                <Slider
                  value={[point.rate]}
                  onValueChange={([value]) => handleRateChange(point.month, value)}
                  min={0}
                  max={10}
                  step={0.1}
                  className="flex-1"
                />

                <Input
                  type="number"
                  value={point.rate.toFixed(2)}
                  onChange={(e) => handleRateChange(point.month, parseFloat(e.target.value) || 0)}
                  min={0}
                  max={10}
                  step={0.1}
                  className="text-right"
                />
              </motion.div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
